// extracted by mini-css-extract-plugin
export default {"phone":"InvocaNumber_phone__H8lYl","contactNumber":"InvocaNumber_contactNumber__7yF8G"};